import React from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { SweepstakesDataProvider } from '../../../contexts/SweepstakesDataContext';
import { SweepstakesDrawerProvider } from '../../../contexts/SweepstakesDrawerContext';

export const SweepstakesWrapper = ({ children, cacheKey, sweepstakesData, useRestAPI }) => {
  return (
    <QueryProvider cacheKey={cacheKey || 'sweepstakes-data-source'}>
      <SweepstakesDataProvider sweepstakesData={sweepstakesData} useRestAPI={useRestAPI}>
        <SweepstakesDrawerProvider>
          {children}
        </SweepstakesDrawerProvider>
      </SweepstakesDataProvider>
    </QueryProvider>
  );
};

SweepstakesWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  cacheKey: PropTypes.string.isRequired,
  sweepstakesData: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    logo: PropTypes.string,
    status: PropTypes.string,
    expirationDate: PropTypes.string,
    isOptedIn: PropTypes.bool,
    completedSteps: PropTypes.number,
    steps: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      iconUrl: PropTypes.string,
      completed: PropTypes.bool,
    })),
  }),
};

SweepstakesWrapper.defaultProps = {
  sweepstakesData: null,
};